import ReserveVue from '@/views/member/reservation/reservation.vue';

const basePath = '/member/reservation';
const role = 'member'; // 角色身份

export const M_RESERVATION_INDEX = 'm-reservation-index';
export const M_RESERVATION_CREATE = 'm-reservation-create';
export const M_RESERVATION_SUCCESS = 'm-reservation-success';
export const M_RESERVATION_LANDING_PAGE = 'm-reservation-landing-page';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: ReserveVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: M_RESERVATION_INDEX,
      component: () => import(
        /* webpackChunkName: "reservation" */
        `@/views/${role}/reservation/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/create/:id`,
      name: M_RESERVATION_CREATE,
      props: true,
      component: () => import(
        /* webpackChunkName: "reservation" */
        `@/views/${role}/reservation/create.vue`
        ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/create`,
      name: M_RESERVATION_CREATE,
      component: () => import(
        /* webpackChunkName: "reservation" */
        `@/views/${role}/reservation/create.vue`
        ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/success`,
      name: M_RESERVATION_SUCCESS,
      component: () => import(
        /* webpackChunkName: "success" */
        `@/views/${role}/reservation/success.vue`
        ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/landing-page`,
      name: M_RESERVATION_LANDING_PAGE,
      component: () => import(
        /* webpackChunkName: "success" */
        `@/views/${role}/reservation/landing-page.vue`
        ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
